export const Types = {
    GET_ALL_EQUIPMENT_BY_AREA_GROUP: "GET_ALL_EQUIPMENT_BY_AREA_GROUP",
    SET_ALL_EQUIPMENT_BY_AREA_GROUP: "SET_ALL_EQUIPMENT_BY_AREA_GROUP",
    SET_CREATE_MULTIPLE_PM: "SET_CREATE_MULTIPLE_PM",

    POST_CREATE_MULTIPLE_PM: "POST_CREATE_MULTIPLE_PM",
    SHOW_SNACK_MESSAGE: "SHOW_SNACK_MESSAGE",
};

export const getAllEquipmentsByAreaGroup = (payload) => ({
    type: Types.GET_ALL_EQUIPMENT_BY_AREA_GROUP,
    payload: payload
});

export const setAllEquipmentsByAreaGroup = (payload) => ({
    type: Types.SET_ALL_EQUIPMENT_BY_AREA_GROUP,
    payload,
});

export const postCreateMultiplePM = (payload) => ({
    type: Types.POST_CREATE_MULTIPLE_PM,
    payload,
});

export const setCreateMultiplePM = (payload) => ({
    type: Types.SET_CREATE_MULTIPLE_PM,
    payload,
});

export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE,
    payload,
});

